import script from "./SearchTransaction.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchTransaction.vue?vue&type=script&setup=true&lang=js"

import "./SearchTransaction.vue?vue&type=style&index=0&id=5b49c0e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b49c0e2"]])

export default __exports__